import overArg from './_overArg.js';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

export default nativeKeys;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash-es/_nativeKeys.js
// module id = 3465
// module chunks = 0